
// Utility functions for distance conversions and formatting

export const kmToMiles = (km: number): number => {
  return km * 0.621371; // 1 km = 0.621371 miles
};

export const formatDistanceInMiles = (km: number): string => {
  const miles = kmToMiles(km);
  return `${Math.round(miles)} miles`;
};

export const formatBroadcastRadius = (km: number): string => {
  const miles = kmToMiles(km);
  if (miles < 1) {
    return `${Math.round(miles * 10) / 10} miles`;
  }
  return `${Math.round(miles)} miles`;
};
